import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonBroadcastService } from '@caslink/common-client/ng-app/common-broadcast/common-broadcast.service';
import { Subscription } from 'rxjs';
import { DeviceLocationDeviceDetail } from '../shared/models/device-location-device-detail.interface';
import { DeviceLocationModuleDetail } from '../shared/models/device-location-module-detail.interface';
import { EventTypes } from '../shared/models/event-types.enum';
import { DeviceStatusService } from '../shared/services/device-status.service';
import FirmwareImageStatus = CASLink.Device.Ui.ViewModel.Device.FirmwareImageStatus;
import { DetailViewService } from '../shared/services/detail-view.service';

@Component({
    selector: 'dl-device-card',
    templateUrl: './device-card.component.html',
    styleUrls: ['./device-card.component.scss']
})
export class DeviceCardComponent implements OnInit, OnDestroy {
    public static $name: string = 'deviceCard';

    @Input() device: DeviceLocationDeviceDetail;
    @Input() module: DeviceLocationModuleDetail;
    @Input() index: number;

    readerStatusView: boolean = false;
    dateFormat = 'MM/DD/YYYY @ h:mm:ss A';

    private toggleReaderViewSubscription: Subscription;

    get isPendingVersionAvailable(): boolean {
        return this.device.firmwareUpdateStatus !== null &&
            this.device.firmwareUpdateStatus !== undefined &&
            this.device.firmwareUpdateStatus !== FirmwareImageStatus.NoImage;
    }

    constructor(
        public detailViewService: DetailViewService,
        public deviceStatusService: DeviceStatusService,
        private commonBroadcastService: CommonBroadcastService
    ) {
    }

    ngOnInit() {
        this.device.$index = this.index;
        this.device.$name = `${this.device.sequence} - ${this.device.category}`;
        this.device.$nameLower = this.device.$name.toLowerCase();

        this.toggleReaderViewSubscription = this.commonBroadcastService.on<{ show: boolean }>(EventTypes.ToggleReaderView)
            .subscribe(data => this.readerStatusView = data.show);
    }

    ngOnDestroy(): void {
        this.toggleReaderViewSubscription?.unsubscribe();
    }

    shouldDrag(): boolean {
        return this.device.category !== 'module';
    }

    isEditable(): boolean {
        return this.device?.configurations?.length > 0;
    }

    isModule(): boolean {
        return this.device.category === 'module';
    }
}
